import React, { PureComponent } from "react";

import numeral from "numeral";
import moment from "moment";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

export default class ModelFeedback extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      projectSettings,
      scenarioSegmentFeedback,
      updateScenarioSegmentFeedback,
      userId,
      postComment,
      deleteComment
    } = this.props;

    if (!projectSettings || projectSettings.isLoading !== false) {
      return (
        <LoadingIndicator
          style={{ width: "60px", height: "36px", transform: "scale(0.40)", margin: "-6px auto 0px auto" }}
        />
      );
    }

    const likeCount = scenarioSegmentFeedback.likes;
    const dislikeCount = scenarioSegmentFeedback.dislikes;
    const commentCount = scenarioSegmentFeedback.commentsCount;
    const currVote = scenarioSegmentFeedback.status;

    const retComments = scenarioSegmentFeedback.comments;

    return (
      <div className={styles.eFeedBack}>
        <ButtonGroup>
          <Button
            onClick={() => updateScenarioSegmentFeedback(currVote === "LIKE" ? "NONE" : "LIKE")}
            active={currVote === "LIKE"}
            style={{ padding: "5px" }}
          >
            {likeCount ? likeCount + " " : ""}
            <FontAwesomeIcon icon={faThumbsUp} />
          </Button>
          <Button
            onClick={() => updateScenarioSegmentFeedback(currVote === "DISLIKE" ? "NONE" : "DISLIKE")}
            active={currVote === "DISLIKE"}
            style={{ padding: "5px" }}
          >
            {dislikeCount ? dislikeCount + " " : ""}
            <FontAwesomeIcon icon={faThumbsDown} />
          </Button>
        </ButtonGroup>
        <div className={styles.dComments}>
          <OverlayTrigger
            placement="bottom"
            trigger={["click"]}
            rootClose
            overlay={
              <Popover id="popover-positioned-bottom" title={"Comments"}>
                <div className={styles.feedbackSection}>
                  <div className={styles.feedbackComments}>
                    {retComments.map((comment) => (
                      <CommentItem
                        key={"comment" + comment.id}
                        comment={comment}
                        deleteComment={deleteComment ? () => deleteComment(comment.id) : undefined}
                        isCreator={comment.created_by && comment.created_by.id === userId}
                      />
                    ))}
                  </div>
                  <AddComment postComment={postComment} defaultOpen={!commentCount} />
                </div>
              </Popover>
            }
          >
            <a className={styles.fCommentsLink}>{commentCount + " Comment" + (commentCount === 1 ? "" : "s")}</a>
          </OverlayTrigger>
        </div>
      </div>
    );
  }
}

class CommentItem extends React.PureComponent {
  render() {
    const { comment, deleteComment, isCreator } = this.props;

    return (
      <div className={styles.commentItemWrapper}>
        <div className={styles.commentMessage}>{comment.message}</div>
        <div className={styles.commentAuthor}>{comment.created_by ? comment.created_by.fullname : ""}</div>
        <div className={styles.commentTime}>
          {moment.utc(comment.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")}
        </div>
        <div className={styles.commentActions}>
          {isCreator && deleteComment ? <a onClick={deleteComment}>Delete</a> : ""}
        </div>
      </div>
    );
  }
}

class AddComment extends React.Component {
  state = { isEdit: Boolean(this.props.defaultOpen), commentText: "" };
  handleClose() {
    this.setState({ isEdit: false, commentText: "" });
  }
  handleOpen() {
    this.setState({ isEdit: true });
  }
  render() {
    const { postComment } = this.props;
    const { isEdit, commentText } = this.state;
    return (
      <div className={styles.addCommentWrapper}>
        <div className={styles.addCommentLink}>
          <Icon type={"chatPurple"} size={13} />
          <a onClick={() => (isEdit ? this.handleClose() : this.handleOpen())}>{"Add Comment"}</a>
        </div>
        <div className={styles.addCommentEdit + " " + (!isEdit ? styles.hide : "")}>
          <textarea
            className={styles.addCommentInput}
            placeholder={"Enter Comment"}
            value={commentText}
            onChange={(e) => this.setState({ commentText: e.target.value })}
            rows={3}
          />
          <div className={styles.addCommentButtons}>
            <Button type={"secondary"} onClick={() => this.handleClose()}>
              {"Cancel"}
            </Button>
            <Button
              style={{ marginLeft: "auto" }}
              type={"primary"}
              onClick={() => {
                this.handleClose();
                return postComment(commentText);
              }}
            >
              {"Add Comment"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
